<div
  class="tw-flex tw-flex-col tw-h-full tw-items-end tw-justify-center tw-text-dt-text-headings tw-text-sm"
>
  <span
    class="tw-font-medium tw-text-right"
    [ngClass]="{
      'tw-text-dt-text-in-primary': balance > 0 && !isLinked,
      'tw-text-dt-text-out-primary': balance < 0 && !isLinked,
      'tw-text-dt-text-secondary': balance === 0 && !isLinked,
      '!tw-text-dt-text-tertiary !tw-font-normal': isLinked,
      '!tw-text-dt-text-secondary tw-font-normal': isBalanceAlignment,
    }"
    >{{
      triggerByEye ? (balance | macroNumber: symbol | asterisks) : (balance | macroNumber: symbol)
    }}</span
  >
</div>
